export default "__VITE_ASSET__8daa4d39__"